import { ref } from 'vue';

export function useAutoShutdownTimes() {
  const autoShutdownTimes = ref([
    // {
    //   label: '10MIN',
    //   interval: 600,
    // },
    // {
    //   label: '20MIN',
    //   interval: 1200,
    // },
    {
      label: '30MIN',
      interval: 1800,
    },
    {
      label: '1HR',
      interval: 3600,
    },
    // {
    //   label: '2HR',
    //   interval: 7200,
    // },
    {
      label: '3HR',
      interval: 10800,
    },
    {
      label: '12HR',
      interval: 43200,
    },
    // {
    //   label: '1D',
    //   interval: 86400,
    // },
    /**
     * Por enquanto deixei a maior opção máximo como 12 horas, pois assim
     * não precisamos filtrar esses tempos de acordo com a caixa de entrada
     * (Whats oficial possui maximo de 24 horas para resposta)
     */
    // {
    //   label: '2D',
    //   interval: 172800,
    // },
    // {
    //   label: '3D',
    //   interval: 259200,
    // },
  ]);

  return { autoShutdownTimes };
}
